import { defineMessages } from 'dibs-react-intl';

export const priceStatsMessages = defineMessages({
    dozens: {
        id: 'abf.SbSharedMarketTrends.priceStats.countWord.dozens',
        defaultMessage: 'dozens',
    },
    hundreds: {
        id: 'abf.SbSharedMarketTrends.priceStats.countWord.hundreds',
        defaultMessage: 'hundreds',
    },
    thousands: {
        id: 'abf.SbSharedMarketTrends.priceStats.countWord.thousands',
        defaultMessage: 'thousands',
    },
    itemsSold: {
        id: 'abf.SbSharedMarketTrends.priceStats.itemsSold',
        defaultMessage: 'Items Sold',
    },
    averageSalePrice: {
        id: 'abf.SbSharedMarketTrends.priceStats.averageSalePrice',
        defaultMessage: 'Average Sale Price',
    },
    priceRange: {
        id: 'abf.SbSharedMarketTrends.priceStats.priceRange',
        defaultMessage: 'Price Range',
    },
    valueChange: {
        id: 'abf.SbSharedMarketTrends.priceStats.valueChange',
        defaultMessage: '1-Year Value Change',
    },
    itemsSoldTooltip: {
        id: 'abf.SbSharedMarketTrends.priceStats.itemsSoldTooltip',
        defaultMessage: 'The total number of items sold to date.',
    },
    priceRangeTooltip: {
        id: 'abf.SbSharedMarketTrends.priceStats.priceRangeTooltip',
        defaultMessage:
            'The 25th and 75th percentile sale prices of items sold in the last 12 months.',
    },
    averageSalePriceTooltip: {
        id: 'abf.SbSharedMarketTrends.priceStats.averageSalePriceTooltip',
        defaultMessage: 'The median sale price of items sold in the last 12 months.',
    },
    valueChangeTooltip: {
        id: 'abf.SbSharedMarketTrends.priceStats.valueChangeTooltip',
        defaultMessage:
            'The percentage change in the average sale price in the last 12 months compared to the prior 12 months.',
    },
    question: {
        id: 'abf.SbSharedMarketTrends.priceStats.question',
        defaultMessage: 'What is the price of {topic}?',
    },
});
